<template>
	<div ref="googleMap"></div>
</template>

<script>
// Importing loader module
import GoogleMapsApiLoader from "google-maps-api-loader";

export default {
	// Get props from parent component (U can change needed props)
	props: {
		markers: Array,
		center: Object,
		zoom: Number,
		fitness: Boolean,
	},
	data() {
		return {
			// Declarate global variable
			google: null,
			map: null,
			apiKey: "AIzaSyDQNm0sg6OhKh6eZvlGhwdIuUl4EYxoQlk",
			mapConfig: {
				// Set lat and lng from props (Important option)
				center: this.center,
				zoom: this.zoom,
				zoomControl: false,
				scaleControl: true,
				scrollwheel: true,
				streetViewControl: false,
				mapTypeId: "satellite",
				fullscreenControl: true,
				// Google Map Styles: https://mapstyle.withgoogle.com/
				styles: [
					{
						featureType: "water",
						stylers: [
							{
								saturation: 43,
							},
							{
								lightness: -11,
							},
							{
								hue: "#0088ff",
							},
						],
					},
					{
						featureType: "road",
						elementType: "geometry.fill",
						stylers: [
							{
								hue: "#ff0000",
							},
							{
								saturation: -100,
							},
							{
								lightness: 99,
							},
						],
					},
					{
						featureType: "road",
						elementType: "geometry.stroke",
						stylers: [
							{
								color: "#808080",
							},
							{
								lightness: 54,
							},
						],
					},
					{
						featureType: "landscape.man_made",
						elementType: "geometry.fill",
						stylers: [
							{
								color: "#ece2d9",
							},
						],
					},
					{
						featureType: "poi.park",
						elementType: "geometry.fill",
						stylers: [
							{
								color: "#ccdca1",
							},
						],
					},
					{
						featureType: "road",
						elementType: "labels.text.fill",
						stylers: [
							{
								color: "#767676",
							},
						],
					},
					{
						featureType: "road",
						elementType: "labels.text.stroke",
						stylers: [
							{
								color: "#ffffff",
							},
						],
					},
					{
						featureType: "poi",
						stylers: [
							{
								visibility: "on",
							},
						],
					},
					{
						featureType: "landscape.natural",
						elementType: "geometry.fill",
						stylers: [
							{
								visibility: "on",
							},
							{
								color: "#EBE5E0",
							},
						],
					},
					{
						featureType: "poi.park",
						stylers: [
							{
								visibility: "on",
							},
						],
					},
					{
						featureType: "poi.sports_complex",
						stylers: [
							{
								visibility: "on",
							},
						],
					},
				],
			},
		};
	},
	// Aysnc is important on API 3.0
	async mounted() {
		// Wait map inited
		const googleMapApi = await GoogleMapsApiLoader({
			apiKey: this.apiKey,
		});
		this.google = googleMapApi;
		this.initializeMap();
	},
	methods: {
		pinSymbol(color, vl) {
			return {
				path: "M 0,0 -1,-2 V -43 H 1 V -2 z M 1,-40 H 50 V -20 H 1 z",
				fillColor: color,
				fillOpacity: 1,
				strokeColor: "#999",
				strokeWeight: 3,
				scale: 1,
				labelOrigin: new vl.google.maps.Point(27, -30),
			};
		},
		// Map init function (initing in async mounted)
		initializeMap() {
			// Get container from ref in template
			const mapContainer = this.$refs.googleMap;
			// Create new map
			this.map = new this.google.maps.Map(mapContainer, this.mapConfig);
			// Hack to pass the event to an internal function
			const vl = this;
			var bounds = new this.google.maps.LatLngBounds();
			// Get and Set markers and tooltip on a map
			this.markers.forEach(function (mker) {
				// create Markers from props from parent component (see below)
				const velp = new vl.google.maps.Marker({
					position: {
						lat: mker.lat,
						lng: mker.lng,
					},
					map: vl.map,
					title: mker.caption,
					icon: vl.pinSymbol(mker.icon.color, vl),
					label: {
						text: mker.id,
						color: "#fff",
						fontFamily: "sans-serif",
						fontWeight: "bold",
						fontSize: "12px",
					},
				});
				//extend the bounds to include each marker's position
				bounds.extend(velp.position);
				// add click open marker event
				velp.addListener("click", function () {
					vl.$router
						.push({ name: "Place", params: { id: mker.id } })
						.catch(() => {});
				});
			});
			if (this.fitness) {
				this.map.fitBounds(bounds);
			}
		},
	},
};
</script>
